var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"body-1 mb-3"},[_vm._v("Категории")]),_c('v-row',_vm._l((_vm.categories),function(category){return _c('v-col',{key:category.id,attrs:{"cols":"12","md":"3"}},[_c('v-card',{attrs:{"router":"","to":{
          name: 'category_orders',
          params: { id: category.id, title: category.title },
        }}},[_c('v-card-title',{staticClass:"body-1"},[_vm._v(" "+_vm._s(category.title.length > 23 ? category.title.slice(0, 23) + "..." : category.title)+" ")]),_c('v-card-subtitle',[_vm._v(" Заявок "+_vm._s(category.orders))])],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }